import ArticalCrad from './ArticalCard';
import ArticalSkeleton from './ArticalSkeleton';

const Articals = ({ articles, loading, limit }) => {
  const skeletons = Array.from({ length: limit }, (_, index) => <ArticalSkeleton key={index} />);

  return (
    <div className="container">
      <div className="flex flex-col items-center justify-center">
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-x-[57px] gap-y-[48px] relative z-0">
          {loading ? <>{skeletons}</> : articles.map((article, index) => <ArticalCrad article={article} key={index} />)}
        </div>
      </div>
    </div>
  );
};

export default Articals;
